module.exports = __webpack_public_path__ + "static/media/leadership-assessment.73ad28d9.png";